<app-modal
  [open]="open"
  (closed)="onClose()"
>
  <ng-container modal-header>
    <h2>{{ 'creator.dashboard.instagram-modal.title' | transloco }}</h2>
  </ng-container>

  <ng-container modal-body>
    <p class="modal-subtitle">{{ 'creator.dashboard.instagram-modal.subtitle' | transloco }}</p>

    <form class="instagram-modal-form" [formGroup]="form" (submit)="$event.preventDefault()">
      @if (step === 'link') {
        <div class="step step--link">
          <div class="input-group">
            <label for="instagram-url">{{ 'creator.dashboard.instagram-modal.form.label' | transloco }}</label>
            <input
              id="instagram-url"
              type="url"
              formControlName="instagramUrl"
              [placeholder]="'creator.dashboard.instagram-modal.form.placeholder' | transloco"
            />
            @if (instagramControl) {
              <div class="field-errors">
                @if (instagramControl.touched && instagramControl.errors?.['required']) {
                  <p>{{ 'creator.dashboard.instagram-modal.errors.required' | transloco }}</p>
                }
                @if (instagramControl.touched && instagramControl.errors?.['invalidUrl']) {
                  <p>{{ 'creator.dashboard.instagram-modal.errors.invalid-url' | transloco }}</p>
                }
                @if (instagramControl.touched && instagramControl.errors?.['notInstagram']) {
                  <p>{{ 'creator.dashboard.instagram-modal.errors.not-instagram' | transloco }}</p>
                }
                @if (instagramControl.touched && instagramControl.errors?.['invalidInstagramProfile']) {
                  <p>{{ 'creator.dashboard.instagram-modal.errors.invalid-instagram-profile' | transloco }}</p>
                }
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="step step--share">
          <div class="input-group">
            <label for="profile-link">{{ 'creator.dashboard.instagram-modal.form.shutterflow-link' | transloco }}</label>
            <div class="input-group__input">
              <input id="profile-link" type="text" [value]="profileLink" readonly />
              <button class="button button--secondary" type="button" (click)="copyProfileLink()">
                <i class="fa-regular fa-copy"></i>
                {{ 'creator.dashboard.instagram-modal.copy.label' | transloco }}
              </button>
            </div>
          </div>

          <div class="how-to">
            <h4>{{ 'creator.dashboard.instagram-modal.guide.title' | transloco }}</h4>
            <div class="how-to__step">
              <div class="how-to__badge">1</div>
              <div>
                <p class="how-to__title">{{ 'creator.dashboard.instagram-modal.guide.step1.title' | transloco }}</p>
                <p class="how-to__description">{{ 'creator.dashboard.instagram-modal.guide.step1.description' | transloco }}</p>
              </div>
            </div>
            <div class="how-to__step">
              <div class="how-to__badge">2</div>
              <div>
                <p class="how-to__title">{{ 'creator.dashboard.instagram-modal.guide.step2.title' | transloco }}</p>
                <p class="how-to__description">{{ 'creator.dashboard.instagram-modal.guide.step2.description' | transloco }}</p>
              </div>
            </div>
            <div class="how-to__step">
              <div class="how-to__badge">3</div>
              <div>
                <p class="how-to__title">{{ 'creator.dashboard.instagram-modal.guide.step3.title' | transloco }}</p>
                <p class="how-to__description">{{ 'creator.dashboard.instagram-modal.guide.step3.description' | transloco }}</p>
              </div>
            </div>
          </div>
        </div>
      }
    </form>
  </ng-container>

  <ng-container modal-footer>
    <div class="footer-actions">
      <button class="button button--secondary" type="button" (click)="onClose()">
        {{ 'creator.dashboard.instagram-modal.actions.close' | transloco }}
      </button>

      @if (step === 'link') {
        <button
          class="button button--primary"
          type="button"
          [disabled]="!form.valid"
          (click)="goToNextStep()"
        >
          {{ 'creator.dashboard.instagram-modal.actions.next' | transloco }}
          <i class="fa-solid fa-arrow-right"></i>
        </button>
      } @else {
        <button
          class="button button--primary"
          type="button"
          [disabled]="!hasCopiedProfileLink || isSubmitting"
          (click)="submit()"
        >
          {{ 'creator.dashboard.instagram-modal.actions.submit' | transloco }}
        </button>
      }
    </div>
  </ng-container>
</app-modal>
